import styled from 'styled-components';

const StyledRightContainer = styled.div`
	position: absolute;
	top: 80px;
	right: 80px;
	display: flex;
	gap: 40px;
`;

const StyledBoost = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 20px;
`;

const StyledControlsContainer = styled.div`
	position: absolute;
	right: 0;
	bottom: 80px;
	display: flex;
	justify-content: space-between;
	padding: 0 80px;
`;

export { StyledBoost, StyledControlsContainer, StyledRightContainer };
